import { render, staticRenderFns } from "./bdAccount.vue?vue&type=template&id=bb9d0376"
import script from "./bdAccount.vue?vue&type=script&lang=js"
export * from "./bdAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb9d0376')) {
      api.createRecord('bb9d0376', component.options)
    } else {
      api.reload('bb9d0376', component.options)
    }
    module.hot.accept("./bdAccount.vue?vue&type=template&id=bb9d0376", function () {
      api.rerender('bb9d0376', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/bdAccount.vue"
export default component.exports